import { errorMessages } from '@/utils/errorMessages';
import { getLocalStorageValue, localStorageKey } from '@/utils/utils';

// Runtime USFM Service URL cache, populated by useAppConfig on mount
let _usfmServiceUrl: string | undefined;

export interface ExportRequest {
  projectId: number;
  bookId: string;
  documentType?: 'HUMAN' | 'MACHINE' | 'ALL';
}

export interface ExportErrorResponse {
  errorMessage: string;
}

type UsfmExportResponse = {
  url: string;
};

export function setUsfmServiceUrl(url: string) {
  _usfmServiceUrl = url.replace(/\/$/, '');
}

const getStoredAuthToken = (): string => {
  const token = getLocalStorageValue(localStorageKey.wovenToken);
  return token ? `Bearer ${token}` : '';
};

export const exportToUSFM = async ({
  projectId,
  bookId,
  documentType,
}: ExportRequest): Promise<void | ExportErrorResponse> => {
  try {
    if (!_usfmServiceUrl) {
      return { errorMessage: errorMessages.usfmURLVariableMissing };
    }

    const exportResponse = await fetch(`${_usfmServiceUrl}/export`, {
      body: JSON.stringify({
        projectId,
        bookId,
        ...(documentType !== undefined && { documentType }),
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: getStoredAuthToken(),
      },
      method: 'POST',
    });

    if (!exportResponse.ok) {
      return {
        errorMessage: errorMessages.usfmExportResponseFailed,
      };
    }

    const exportData = await exportResponse.json().catch(() => null) as Partial<UsfmExportResponse> | null;

    if (!exportData?.url) {
      return { errorMessage: errorMessages.usfmExportMissingUrl };
    }

    window.location.assign(exportData.url);
  } catch (error) {
    console.error('Error exporting to USFM:', error);
    return { errorMessage: errorMessages.usfmExportFetchFailed };
  }
};
